import { createScopedInstance, getLanguage } from '@citrite/translate';
import { languages, locale } from '../common/locales';

export const { t: tmp } = createScopedInstance({
	resources: languages,
	namespace: 'docgen-pilet-ui',
	interpolation: {
		escapeValue: false,
	},
});

export const t: (str: string, opts?: any) => string = tmp;

export type LocaleString = Partial<Record<locale, string>>;
/**
 * Used to receive correct locale value from a localization string object.
 * Commonly used to evaluate view configuration block/zone parameters
 * Defaults to English
 */
export const getLocaleValue = (localizationObject?: LocaleString) => {
	const language = getLanguage() as locale;
	return localizationObject?.[language || 'en'];
};
